<header><img src="assets/img/logo.png" width="40%"></header>

<!-- Modal -->
<div class="popup" *ngIf="wifiModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close">
                    <!-- <span aria-hidden="true" data-dismiss="modal">×</span> -->
                </button>
                <h3 class="modal-title modal-title-color">Please use your Safaricom Internet to access this service.
                </h3>
                <!-- <a type="button" class="btn btn-primary" (click)="closeModal()">OK</a> -->
            </div>
        </div>
    </div>
</div>